module.exports = __webpack_public_path__ + "img/wechat5.5596b06b.jpg";